import { useEffect, useState } from "react";
import StatCard from "../components/StatCard";
import API from "../services/api";

export default function Dashboard() {
    const [stats, setStats] = useState({
        total: 0,
        newLeads: 0,
        closed: 0,
    });

    useEffect(() => {
        fetchStats();

        const interval = setInterval(fetchStats, 10000);
        return () => clearInterval(interval);
    }, []);

    const fetchStats = async () => {
        try {
            const res = await API.get("/leads");
            const leads = res.data || [];

            const total = leads.length;
            const newLeads = leads.filter((l) => l.status === "New").length;
            const closed = leads.filter((l) => l.status === "Closed").length;

            setStats({
                total,
                newLeads,
                closed,
            });
        } catch (err) {
            console.error("Dashboard error", err);
        }
    };

    return (
        <div className="p-8 space-y-6 overflow-auto">
            <h1 className="text-3xl font-bold">Welcome Back 👋</h1>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <StatCard title="Total Leads" value={stats.total} />
                <StatCard title="New Leads" value={stats.newLeads} />
                <StatCard title="Closed Deals" value={stats.closed} />
            </div>
        </div>
    );
}